import { createStore } from 'vuex'

export default createStore({
  state: {
    adminurl:'https://adminprime.nsmlimited.com/',
    url:'https://primen.nsmlimited.com/',

    // adminurl:'http://192.168.10.11:8000/',
    // url:'http://localhost:8080/', 

    //  adminurl:'http://localhost:8000/',
    // url:'http://localhost:8080/',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})



